export default {
  referrers: {
    byId: {},
    allIds: []
  },
  rawReferrers: [],
  totalReferrers: null,
  referrerFilters: {
    orderBy: "",
    orderType: "",
    searchString: "",
    type: null
  },
  referrersCustomFieldsDefinitions: {
    byId: {},
    allIds: []
  },
  referrersLinkedApplications: {
    byId: {},
    allIds: []
  },
  referrersLinkedProfiles: {
    byId: {},
    allIds: []
  },
  linkedProfilesLabelTranslationMap: {}
};